import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { DistributionList } from './distribution-list.model';
import { User } from './user.model';

@Component({
  selector: 'app-distribution-lists-dialog',
  templateUrl: './distribution-lists-dialog.component.html',
  styleUrls: ['./distribution-lists-dialog.component.scss']
})
export class DistributionListsDialogComponent implements OnInit {

  lists: DistributionList[];
  loading: boolean = false;
  editMode: boolean = false;
  selectedList: DistributionList;
  workflowId: number;
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DistributionListsDialogComponent>) { }

  ngOnInit() {
    this.workflowId = this.data.workflowId;
  }

  selectList(list: DistributionList) {
    this.dialogRef.close(list);
  }

  newList() {
    this.editMode = true;
    this.selectedList = null;
  }

  editList(list: DistributionList) {
    this.editMode = true;
    this.selectedList = list;
  }

  onFormCancel() {
    this.editMode = false;
    this.selectedList = null;
  }

  onFormFinished() {
    this.editMode = false;
    this.selectedList = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/users/distribution-lists-dialog.component.ts